import { render, staticRenderFns } from "./VentesView.vue?vue&type=template&id=68113f0a&scoped=true"
import script from "./VentesView.vue?vue&type=script&lang=js"
export * from "./VentesView.vue?vue&type=script&lang=js"
import style0 from "./VentesView.vue?vue&type=style&index=0&id=68113f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68113f0a",
  null
  
)

export default component.exports